import {I18n} from '@aws-amplify/core';
import {Badge} from '@mantine/core';

/**
 * FNP-918: the price `active` flag as a badge (§13).
 *
 * ⚠️ Colours are Mantine THEME TOKENS, not hex literals. This file previously
 * hardcoded '#007bff' / '#6c757d', which violates §2 "No hardcoded colours" —
 * a hex value is fixed against whichever background the author happened to be
 * looking at, so a badge that reads fine in light mode loses contrast in dark.
 * Theme tokens resolve per scheme.
 *
 * ⚠️ Text, not colour alone (§13): the badge renders Active / Inactive rather
 * than the old lowercase "yes"/"no". "no" says nothing once it is separated
 * from its column header — in a filter chip, a detail panel, or read aloud by
 * a screen reader — whereas "Inactive" carries its own meaning.
 *
 * `active` is nullable in practice; absent is treated as inactive, which is
 * what the API means by it, rather than a third "unknown" state with no
 * business meaning.
 */
export const StatusBadge = ({active}: {active?: boolean}) => {
    const isActive = active === true;

    return (
        <Badge
            color={isActive ? 'green' : 'gray'}
            variant='light'
        >
            {isActive ? I18n.get('Active') : I18n.get('Inactive')}
        </Badge>
    );
};
